import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { UserService } from '../../../core/user/user.service';
import { first } from 'rxjs/operators';
import { AlertService } from '../../../shared/alert/alert.service';
import { UtilsService } from '../../../services/utils.service';

@Component({
    selector: 'app-payment-methods',
    templateUrl: './payment-methods.component.html',
    styleUrls: ['./payment-methods.component.scss']
})
export class PaymentMethodsComponent implements OnInit {
    public form: FormGroup;
    public countries = [];
    userBillingAddress = null;
    loading = false;
    alertOptions = {
        autoClose: true,
        keepAfterRouteChange: false,
        id: 'payment-methods-alert'
    };

    public constructor(
        private formBuilder: FormBuilder,
        private userService: UserService,
        private utilsService: UtilsService,
        private alertService: AlertService
    ) {}

    ngOnInit(): void {
        this.getCountries();
        this.getUserBillingAddress();
        this.initForm();
    }

    getUserBillingAddress() {
        this.userService
            .getUserBillingAddress()
            .pipe(first())
            .subscribe({
                next: resp => {
                    this.userBillingAddress = resp;
                    this.initForm(this.userBillingAddress);
                },
                error: error => {
                    this.alertService.error('Error: ' + error, this.alertOptions);
                    this.initForm();
                }
            });
    }

    getCountries() {
        this.utilsService.getCountries().subscribe(resp => {
            this.countries = resp;
        });
    }

    private initForm(userBillingAddress?): void {
        this.form = this.formBuilder.group({
            firstName: new FormControl(
                userBillingAddress ? userBillingAddress.firstName : null,
                RxwebValidators.required({ message: 'First name is required.' })
            ),
            lastName: new FormControl(
                userBillingAddress ? userBillingAddress.lastName : null,
                RxwebValidators.required({ message: 'Last name is required.' })
            ),
            country: new FormControl(
                userBillingAddress ? userBillingAddress.country : null,
                RxwebValidators.required({
                    message: 'Country is required.'
                })
            ),
            city: new FormControl(
                userBillingAddress ? userBillingAddress.city : null,
                RxwebValidators.required({
                    message: 'City is required.'
                })
            ),
            street: new FormControl(
                userBillingAddress ? userBillingAddress.street : null,
                RxwebValidators.required({
                    message: 'Street is required.'
                })
            ),
            building: new FormControl(
                userBillingAddress ? userBillingAddress.building : null,
                RxwebValidators.required({
                    message: 'Building/Floor is required.'
                })
            ),
            postalCode: new FormControl(userBillingAddress ? userBillingAddress.postalCode : null)
        });
    }

    savePaymentMethods() {
        this.alertService.clear();
        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }
        this.loading = true;
        this.userService
            .updateUserBillingAddress(this.form.value)
            .pipe(first())
            .subscribe({
                next: () => {
                    this.alertService.success(
                        'Payment methods updated successfully',
                        this.alertOptions
                    );
                },
                error: error => {
                    this.alertService.error('Error: ' + error, this.alertOptions);
                    this.loading = false;
                }
            });
    }
}
